// Same additional field can repeat per brand (Section B) -> key = fieldId_brandId
export const buildFieldKey = (fieldId, brandId) =>
    brandId != null ? `${fieldId}_${brandId}` : `${fieldId}`;